import { AdMarketplaceConfig, AdMarketplaceResponse, AdMarketplaceError } from '../types';

export class AdMarketplaceApiClient {
    constructor(private readonly config: AdMarketplaceConfig) {
        this.config = config;
    }

    async getSuggestions(keyword: string): Promise<AdMarketplaceResponse> {
        const params = new URLSearchParams({
            plid: this.config.plid,
            qt: keyword,
            v: '2.0',
            'results-ta': (this.config.resultsTa || 1).toString(),
            'results-pa': (this.config.resultsPa || 0).toString(),
            rfr: encodeURIComponent(this.config.rfr),
            // locale: this.config.locale || 'en-US',
            // ip: '94.4.42.244',
        });

        const url = `https://${this.config.partnerName}.is.ampfeed.com/is?${params.toString()}`;
        
        try {
            const response = await fetch(url);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data?.status?.code) {
                const error: AdMarketplaceError = data;
                throw new Error(`AdMarketplace API error: ${error.status.code} - ${error.status.text}`);
            }
            
            return data as AdMarketplaceResponse;
        } catch (error) {
            console.error('AdMarketplace API call failed:', error);
            throw error;
        }
    }
}


